import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

async function getMerchantEnrollmentBanks(merchantId: number): Promise<any> {
  try {
    return (await axiosInstance.get("/MerchantSoftPOSEnrollment/List?merchantId=" + merchantId)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetMerchantEnrollmentBanks() {
  return useMutation<any, Error, number>((variables) =>
    getMerchantEnrollmentBanks(variables)
  );
}